export default {

  todaysSelfCheckIn(context, data) {
    context.commit('todaysSelfCheckIn', data);
  },
  
};
